// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.availability-container {
    background: var(--clr-grey-9);
    border-radius: var(--radius);
    padding: 2.5rem;
    box-shadow: var(--shadow-3);
    max-width: 1120px;
    width: 90%;
    margin: 3rem auto;
    font-family: var(--ff-primary);
    color: var(--clr-grey-2);
    transition: var(--transition);
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    min-height: 70vh;             
    justify-content: flex-start;
    border: 3px solid var(--clr-primary-3);
  }
  
  .booking-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;
  }
  
  .proceed-btn {
    background-color: var(--clr-primary-5);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s ease, transform 0.2s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
  }
  
  .proceed-btn:hover {
    background-color: var(--clr-primary-4);
    transform: translateY(-1px);
  }
  
  /* Responsive container spacing */
  @media (max-width: 768px) {
    .availability-container {
      padding: 1rem;
      margin: 1rem;
    }
  
    .proceed-btn {
      width: 100%;
      justify-content: center;
      font-size: 0.95rem;
    }
  
    .booking-footer {
      justify-content: center;
    }
  }
  
  .loading-spinner_v3 {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 0;
    text-align: center;
    color: var(--clr-grey-6);
    font-size: 1rem;
    position: relative;
  }
  
  .loading-spinner_v3::before {
    content: "";
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.75rem;
    border: 3px solid var(--clr-grey-5);
    border-top-color: var(--clr-primary-7);
    border-radius: 50%;
    animation: spinLoader 0.8s linear infinite;
  }
  
  @keyframes spinLoader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  .slot-info-banner {
    background-color: var(--clr-primary-10);
    padding: 0.85rem 1rem;
    margin-bottom: 1rem;
    border-left: 4px solid var(--clr-primary-5);
    font-size: 0.95rem;
    color: var(--clr-grey-1);
    border-radius: 6px;
    line-height: 1.6;
  }
  
  .pb-modal-content {
    background-color: var(--clr-white);
    padding: 2rem 2.25rem;
    border-radius: var(--radius);
    width: 92%;
    max-width: 520px;
    box-shadow: var(--shadow-4);
    font-family: var(--ff-primary);
    animation: fadeIn 0.3s ease-in-out;
    border: 1px solid var(--clr-grey-9);
  }
  
  .pb-modal-content h3 {
    margin-top: 0;
    font-size: 1.7rem;
    color: var(--clr-grey-1);
    margin-bottom: 1.2rem;
    text-align: center;
    border-bottom: 1px solid var(--clr-grey-9);
    padding-bottom: 0.75rem;
    letter-spacing: 0.5px;
  }
  
  .pb-summary {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
    margin-bottom: 2rem;
  }
  
  .pb-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem 0;
    font-size: 1rem;
    border-bottom: 1px dashed var(--clr-grey-9);
  }
  
  .pb-row strong {
    font-weight: 600;
    color: var(--clr-grey-2);
    min-width: 130px;
  }
  
  .pb-row span {
    color: var(--clr-grey-5);
    font-weight: 500;
    text-align: right;
    word-break: break-word;
  }
  
  .pb-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1.5rem;
  }
  
  .pb-confirm-btn,
  .pb-cancel-btn {
    padding: 0.6rem 1.5rem;
    font-size: 1rem;
    border: none;
    border-radius: var(--radius);
    font-weight: 600;
    cursor: pointer;
    transition: var(--transition);
    min-width: 120px;
    text-align: center;
    box-shadow: var(--shadow-1);
  }
  
  .pb-confirm-btn {
    background-color: var(--clr-primary-2);
    color: var(--clr-white);
  }
  
  .pb-confirm-btn:hover {
    background-color: #0a3d26;
  }
  
  .pb-cancel-btn {
    background-color: var(--clr-grey-6);
    color: var(--clr-white);
  }
  
  .pb-cancel-btn:hover {
    background-color: var(--clr-grey-5);
  }
  
  @keyframes fadeIn {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }
  
  /* Responsive - Mobile First */
  @media screen and (max-width: 480px) {
    .pb-modal-content {
      padding: 1.5rem 1.25rem;
    }
  
    .pb-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25rem;
    }
  
    .pb-modal-actions {
      flex-direction: column;
      align-items: stretch;
    }
  
    .pb-confirm-btn,
    .pb-cancel-btn {
      width: 100%;
      min-width: unset;
    }
  }
  
  .pb-success-message {
    text-align: center;
    padding: 20px;
    font-size: 0.95rem;
    color: var(--clr-grey-2);
    animation: fadeIn 0.4s ease-in-out;
  }
  
  .pb-success-message h3 {
    margin-bottom: 10px;
    color: var(--clr-primary-5);
  }
  
  .pb-success-message p {
    margin-bottom: 8px;
    line-height: 1.5;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/NewAdminScheduling/styles/AdminAvailabilityTool.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qDAAqD;IACrD,yCAAyC;EAC3C;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;IACE;MACE,aAAa;MACb,YAAY;IACd;;IAEA;MACE,WAAW;MACX,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,mCAAmC;IACnC,sCAAsC;IACtC,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,uCAAuC;IACvC,qBAAqB;IACrB,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;IAClC,qBAAqB;IACrB,4BAA4B;IAC5B,UAAU;IACV,gBAAgB;IAChB,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;IAClC,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;IAEE,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,sCAAsC;IACtC,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mCAAmC;IACnC,uBAAuB;EACzB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,0BAA0B;MAC1B,UAAU;IACZ;EACF;;EAEA,8BAA8B;EAC9B;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,YAAY;IACd;;IAEA;MACE,sBAAsB;MACtB,oBAAoB;IACtB;;IAEA;;MAEE,WAAW;MACX,gBAAgB;IAClB;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":[".availability-container {\n    background: var(--clr-grey-9);\n    border-radius: var(--radius);\n    padding: 2.5rem;\n    box-shadow: var(--shadow-3);\n    max-width: 1120px;\n    width: 90%;\n    margin: 3rem auto;\n    font-family: var(--ff-primary);\n    color: var(--clr-grey-2);\n    transition: var(--transition);\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    min-height: 70vh;             \n    justify-content: flex-start;\n    border: 3px solid var(--clr-primary-3);\n  }\n  \n  .booking-footer {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 2rem;\n  }\n  \n  .proceed-btn {\n    background-color: var(--clr-primary-5);\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.3s ease, transform 0.2s ease;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);\n  }\n  \n  .proceed-btn:hover {\n    background-color: var(--clr-primary-4);\n    transform: translateY(-1px);\n  }\n  \n  /* Responsive container spacing */\n  @media (max-width: 768px) {\n    .availability-container {\n      padding: 1rem;\n      margin: 1rem;\n    }\n  \n    .proceed-btn {\n      width: 100%;\n      justify-content: center;\n      font-size: 0.95rem;\n    }\n  \n    .booking-footer {\n      justify-content: center;\n    }\n  }\n  \n  .loading-spinner_v3 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem 0;\n    text-align: center;\n    color: var(--clr-grey-6);\n    font-size: 1rem;\n    position: relative;\n  }\n  \n  .loading-spinner_v3::before {\n    content: \"\";\n    width: 1.25rem;\n    height: 1.25rem;\n    margin-right: 0.75rem;\n    border: 3px solid var(--clr-grey-5);\n    border-top-color: var(--clr-primary-7);\n    border-radius: 50%;\n    animation: spinLoader 0.8s linear infinite;\n  }\n  \n  @keyframes spinLoader {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .slot-info-banner {\n    background-color: var(--clr-primary-10);\n    padding: 0.85rem 1rem;\n    margin-bottom: 1rem;\n    border-left: 4px solid var(--clr-primary-5);\n    font-size: 0.95rem;\n    color: var(--clr-grey-1);\n    border-radius: 6px;\n    line-height: 1.6;\n  }\n  \n  .pb-modal-content {\n    background-color: var(--clr-white);\n    padding: 2rem 2.25rem;\n    border-radius: var(--radius);\n    width: 92%;\n    max-width: 520px;\n    box-shadow: var(--shadow-4);\n    font-family: var(--ff-primary);\n    animation: fadeIn 0.3s ease-in-out;\n    border: 1px solid var(--clr-grey-9);\n  }\n  \n  .pb-modal-content h3 {\n    margin-top: 0;\n    font-size: 1.7rem;\n    color: var(--clr-grey-1);\n    margin-bottom: 1.2rem;\n    text-align: center;\n    border-bottom: 1px solid var(--clr-grey-9);\n    padding-bottom: 0.75rem;\n    letter-spacing: 0.5px;\n  }\n  \n  .pb-summary {\n    display: flex;\n    flex-direction: column;\n    gap: 0.9rem;\n    margin-bottom: 2rem;\n  }\n  \n  .pb-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.6rem 0;\n    font-size: 1rem;\n    border-bottom: 1px dashed var(--clr-grey-9);\n  }\n  \n  .pb-row strong {\n    font-weight: 600;\n    color: var(--clr-grey-2);\n    min-width: 130px;\n  }\n  \n  .pb-row span {\n    color: var(--clr-grey-5);\n    font-weight: 500;\n    text-align: right;\n    word-break: break-word;\n  }\n  \n  .pb-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    margin-top: 1.5rem;\n  }\n  \n  .pb-confirm-btn,\n  .pb-cancel-btn {\n    padding: 0.6rem 1.5rem;\n    font-size: 1rem;\n    border: none;\n    border-radius: var(--radius);\n    font-weight: 600;\n    cursor: pointer;\n    transition: var(--transition);\n    min-width: 120px;\n    text-align: center;\n    box-shadow: var(--shadow-1);\n  }\n  \n  .pb-confirm-btn {\n    background-color: var(--clr-primary-2);\n    color: var(--clr-white);\n  }\n  \n  .pb-confirm-btn:hover {\n    background-color: #0a3d26;\n  }\n  \n  .pb-cancel-btn {\n    background-color: var(--clr-grey-6);\n    color: var(--clr-white);\n  }\n  \n  .pb-cancel-btn:hover {\n    background-color: var(--clr-grey-5);\n  }\n  \n  @keyframes fadeIn {\n    from {\n      transform: translateY(20px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0px);\n      opacity: 1;\n    }\n  }\n  \n  /* Responsive - Mobile First */\n  @media screen and (max-width: 480px) {\n    .pb-modal-content {\n      padding: 1.5rem 1.25rem;\n    }\n  \n    .pb-row {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.25rem;\n    }\n  \n    .pb-modal-actions {\n      flex-direction: column;\n      align-items: stretch;\n    }\n  \n    .pb-confirm-btn,\n    .pb-cancel-btn {\n      width: 100%;\n      min-width: unset;\n    }\n  }\n  \n  .pb-success-message {\n    text-align: center;\n    padding: 20px;\n    font-size: 0.95rem;\n    color: var(--clr-grey-2);\n    animation: fadeIn 0.4s ease-in-out;\n  }\n  \n  .pb-success-message h3 {\n    margin-bottom: 10px;\n    color: var(--clr-primary-5);\n  }\n  \n  .pb-success-message p {\n    margin-bottom: 8px;\n    line-height: 1.5;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
